export const VERIFY_STATUS = {
  // 已下架 0
  // 未提交 1
  // 待审核 2
  // 审核通过 3
  // 审核不通过 4
  PUBLISHED: 5, // 已上架
  // 未知 99
};

export const TRUE = "1";
export const FALSE = "0";

export const AMENITIES_TYPES = [
  { k: 0, v: "设施" },
  { k: 2, v: "卫浴" },
  { k: 1, v: "电器" },
  { k: 3, v: "厨房" },
  { k: 4, v: "客房服务" },
];

export const RECOMMENDED_DEDUCT_TYPE = 3;
export const RECOMMENDED_DEDUCT_TYPE_TIP = "设置“宽松”的退款政策，会让更多的房客选择你的房子";

export const UserVerifyStatus = {
  VERIFIED: 5,
};

export const SUPPORT_PHONE = "400-0660-190";
export const SUPPORT_PHONE_RAW = "4000660190";

export const RoomTagTypes = {
  CONVENIENCE: 1,
  QUALITY: 2,
  SPECIAL: 3,
  SIGHT: 4,
  MARKETING: 5,
  PROMO: 6,
  COMMENTS: 7,
};

export const Categories = {
  ZHENGUO: 1,
  DIST: 2,
  ZHILIAN: 3,
};

export const PromotionSubTypes = {
  SPECIAL_OFFER_TONIGHT: 301, // 今夜特价
  LONG_RENT_DISCOUNT: 302, // 连住优惠
  NEW_HOUSE_DISCOUNT: 303, // 新房特惠
  FLASH_DISCOUNT: 304, // 限时优惠
};

export const OrderMarketTypes = {
  PLATFORM_PROMO: 1,
  PLATFORM_COUPON: 2,
  HOST_PROMO: 3,
};

export const OrderMarketTypeNames = {
  [OrderMarketTypes.PLATFORM_PROMO]: "促销活动",
  [OrderMarketTypes.PLATFORM_COUPON]: "优惠券",
  [OrderMarketTypes.HOST_PROMO]: "房东优惠",
};
